import { render, staticRenderFns } from "./gamification-ui.vue?vue&type=template&id=13c3bb42"
var script = {}
import style0 from "./gamification-ui.vue?vue&type=style&index=0&id=13c3bb42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports